/* eslint-disable */
import React from 'react';
import {
  getScoreColor,
  getVariationValues,
  getWidthPercentage,
} from '../../../../../../../helpers/effectReports/chartCounters';
import { IToggleState, Topic } from '../../../../../../../services/reports';
import { CaptionRegularL } from '../../../../../../../styles/globals';
import {
  ValueBar,
  VariationSign,
  Tooltip,
} from '../../../../../SharedEffectReportComponents/EffectReportTemplate/EffectProgressTable/EffectHorizontalChart/ColorBar/ColorBar.styles';
import { MiddleLine } from '../../../../../SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/TimestampSigns/TimestampSigns.styles';
import { Row, Wrapper } from './TopicLevelChart.styles';

interface TopicLevelChartProps {
  data: Topic;
  togglersState: IToggleState;
}

const TopicLevelChart: React.FC<TopicLevelChartProps> = ({ data, togglersState }) => {
  const { average_value, threshold_values, single_respondent_max, single_respondent_min } = data;

  const { variationPosition, variationWidth } = getVariationValues(
    single_respondent_min ?? 0,
    single_respondent_max ?? 0
  );

  const { variation_between_respondents } = togglersState;

  return (
    <Wrapper>
      <CaptionRegularL>{data.label}</CaptionRegularL>
      <Row>
        <ValueBar
          color={getScoreColor(
            average_value,
            threshold_values.low,
            threshold_values.high,
            threshold_values.medium
          )}
          width={getWidthPercentage(data.average_value)}
        />
        {variation_between_respondents && (
          <VariationSign left={variationPosition} width={variationWidth}>
            <Tooltip>
              {`${(single_respondent_min ?? 0).toFixed(1)} - ${(single_respondent_max ?? 0).toFixed(
                1
              )}`}
            </Tooltip>
            <MiddleLine />
          </VariationSign>
        )}
      </Row>
    </Wrapper>
  );
};

export default TopicLevelChart;
